<script setup lang="ts">
defineProps<{
  disabled?: boolean
}>()
</script>

<template>
  <button class="text-left" :class="disabled ? 'text-darkgrey cursor-not-allowed' : 'hover:text-darkgrey'" :disabled="disabled">
    <slot />
  </button>
</template>
